import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { User, useUser } from '../../contexts/UserContext';
import waitForAudioStream, { EventData, OperationStatusEvent } from '../../utils/ServerSideEventConsumer';
import EventsSegment from './EventsSegment';
import NewsSegment from './NewsSegment';
import SegmentMenu from './SegmentMenu';
import WeatherSegment from './WeatherSegment';
import { SegmentType } from './types';
import OperationStatusComponent from '../OperationStatusComponent';

const SegmentChooser: React.FC = () => {
  const [currentSegment, setCurrentSegment] = React.useState<SegmentType>(SegmentType.Weather);
  const { user, setUser } = useUser();
  const [description, setDescription] = useState('');
  const [percent, setPercent] = useState(0);
  const [subtask, setSubtask] = useState('');
  const [showOperationStatus, setShowOperationStatus] = useState(false);

  const refresh = async (segment: SegmentType) => {
    console.log('Refreshing', segment);
    if (user) {
      const newUser: User = structuredClone(user);
      newUser.hlsStreamUrl = '';
      setUser(newUser);
    }

    await axios.post(`${process.env.REACT_APP_API_URL}/refresh`,
      { segment },
      {
        withCredentials: true,
        params: {
          forceUser: JSON.parse(process.env.REACT_APP_USER || '{}')?.email,
        }
      }
    )
  };

  useEffect(() => {
    const statusCallback = async (streamEvent: EventData) => {
      switch (streamEvent.eventType) {
        case 'operation-status':
          const statusEvent: OperationStatusEvent = streamEvent as OperationStatusEvent;
          setDescription(statusEvent.description);
          setPercent(statusEvent.percent);
          setSubtask(statusEvent.subtask);
          setShowOperationStatus(statusEvent.percent < 100);
          break;
      }
    }

    waitForAudioStream.initialize();
    waitForAudioStream.registerCallback('operation-status', statusCallback);
  }, []);

  return (
    <div className="flex flex-col h-screen">
      <div className="flex-grow">
        {(() => {
          switch (currentSegment) {
            case 'events':
              return <EventsSegment />;
            case 'weather':
              return <WeatherSegment />;
            case 'news':
              return <NewsSegment />;
            default:
              return <WeatherSegment />;
          }
        })()}
      </div>
      <div className="h-16">
        <SegmentMenu currentSegment={currentSegment} setCurrentSegment={setCurrentSegment} refresh={refresh} />
      </div>
      <div>
        {showOperationStatus && (
          <div className="absolute z-10 flex items-center justify-center w-full h-full">
            <OperationStatusComponent
              percent={percent}
              description={description}
              subtask={subtask}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SegmentChooser;